import {IonCol, IonGrid, IonItem, IonLabel, IonRow, IonText} from "@ionic/react";
import React from "react";

export const JobRow = ({ label, value, strikethroughValue="", color="", action = null, actionIcon = "", disableAction=false, disabled=false, otherDetails = ""}) => (
    <IonItem
        lines="full"
        color={color}
        detail={!disableAction && typeof action === 'function'}
        detailIcon={typeof action === 'function' ? actionIcon : undefined}
        onClick={typeof action === 'function' ? action : undefined}
        button={typeof action === 'function'}
        disabled={disabled}
    >
        <IonGrid className="ion-no-padding">
            <IonRow>
                <IonCol size="6">
                    <IonLabel className="ion-text-wrap">{label}</IonLabel>
                </IonCol>
                <IonCol size="6">
                    <IonText className="ion-text-wrap" position="fixed">{value}</IonText>
                    {strikethroughValue !== '' &&
                       <IonText style={{ marginLeft: '6px', textDecoration: 'line-through' }} className="ion-text-wrap" position="fixed">{strikethroughValue}</IonText>
                    }
                    {otherDetails !== '' &&
                       <IonText style={{ marginLeft: '6px' }} className="ion-text-wrap" position="fixed">{otherDetails}</IonText>
                    }
                </IonCol>
            </IonRow>
        </IonGrid>
    </IonItem>
);